import { ArrowUpRight, Phone, ShoppingBag } from "lucide-react";
import { LINKS, RESTAURANT } from "../data/site";
import { FadeUp, SectionHead } from "./Motion";

const CARDS = [
  {
    n: "01",
    title: "Order Pickup Online",
    desc: "Build your cart, pay securely, skip the line — ready in 20–30 min",
    href: "/order",
    testid: "order-pickup-link",
    primary: true,
  },
  {
    n: "02",
    title: "Uber Eats",
    desc: "Delivered to your door in 30–45 minutes",
    href: LINKS.uberEats,
    testid: "uber-eats-link",
    external: true,
  },
  {
    n: "03",
    title: "DoorDash",
    desc: "DashPass accepted · pickup available",
    href: LINKS.doorDash,
    testid: "doordash-link",
    external: true,
  },
];

const OrderSection = () => (
  <section id="order" data-testid="order-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="09"
      kicker="Order Online"
      title={<>Dinner is <em className="italic text-gold">one tap away</em></>}
    />

    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {CARDS.map((c, i) => (
        <FadeUp key={c.n} delay={i * 0.1} className="h-full">
          <a
            href={c.href}
            {...(c.external ? { target: "_blank", rel: "noreferrer" } : {})}
            data-testid={c.testid}
            className={`group flex h-full flex-col justify-between gap-12 rounded-2xl border p-8 transition-all duration-500 hover:-translate-y-1.5 md:p-9 ${
              c.primary ? "border-gold/60 bg-gold/[0.07]" : "border-white/10 hover:border-gold/60 hover:bg-gold/5"
            }`}
          >
            <span className={`font-serif text-4xl transition-colors duration-500 ${c.primary ? "text-gold" : "text-white/15 group-hover:text-gold/50"}`}>{c.n}</span>
            <div>
              <h3 className="flex items-center gap-2 font-serif text-2xl md:text-[1.7rem]">
                {c.title}
                {c.primary
                  ? <ShoppingBag size={19} className="text-gold transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
                  : <ArrowUpRight size={19} className="text-gold transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />}
              </h3>
              <p className="mt-2 text-sm text-mist">{c.desc}</p>
            </div>
          </a>
        </FadeUp>
      ))}

      <FadeUp delay={0.3} className="h-full">
        <a
          href={RESTAURANT.phoneHref}
          data-testid="order-call-link"
          className="group flex h-full flex-col justify-between gap-12 rounded-2xl border border-white/10 p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:bg-gold/5 md:p-9"
        >
          <span className="font-serif text-4xl text-white/15 transition-colors duration-500 group-hover:text-gold/50">04</span>
          <div>
            <h3 className="flex items-center gap-2 font-serif text-2xl md:text-[1.7rem]">
              Call to Order <Phone size={19} className="text-gold" />
            </h3>
            <p className="mt-2 font-serif text-xl text-gold">{RESTAURANT.phone}</p>
            <p className="mt-2 text-sm text-mist">Speak to us directly — Jain & custom requests welcome</p>
          </div>
        </a>
      </FadeUp>
    </div>
  </section>
);

export default OrderSection;
